import 'ion-rangeslider'
import { campusesList } from './campuses-list'
import { logoSlider } from './logo-slider'
import { saveStats } from './stats'
import store from './simplestore'
import {loader} from './loader'
import { eligibilityTooltip } from './eligibility'
import { applyTooltip } from './apply'
import { emojiTooltip } from './emoji'
import ranking_info_window from "./ranking";
import featured_info_window from "./featured";

export default function vendorSearch(){
  $(document).ready(function($) {
    let isLoading = false;
    let locationsData = JSON.parse(window.searchpage_data.locationsData);
    let programData = JSON.parse(window.searchpage_data.programData);

    let locationFinder = {
      container:  $('#where-container'),
      selection:  $('#where-container .autocomplete-field_selection'),
      input_text:  $('#location'),
      input_type:  $('#location-type'),
      input_value:  $('#location-value'),
      input_data:  $('#location-data'),
      autocompleteList: function () {
        return this.container.find('.autocomplete-list');
      },
      init: function () {
        var $this = locationFinder, $body = $('body');
        $this.initOnClick();

        $body.on('change keyup', '#location', function(){
          $this.processInput(this);
        });
        $this.autocompleteList().css({'width': $this.container.outerWidth()});
      },
      initOnClick: function(){
        var $this = locationFinder;

        $this.autocompleteList().hover(function () {
          $this.input_text.blur();
        });

        $this.autocompleteList().on('click', 'li.autocomplete-list-item', function(e){
          e.preventDefault();
          if ($(this).hasClass('autocomplete-list-item_no-result')){
            return false;
          }
          if($this.saveSelectedData(this)){
            $(this).closest('.autocomplete-list').hide({
              complete: function () {
                $this.input_text.focus();
              }
            });
          }

          vendorFilter.submitForm();
        });
        $this.selection.on('click', '.autocomplete-field_selection-remove', function(e){
          e.preventDefault();
          $(this).closest('.autocomplete-field_selection-item').remove();
          $this.calculateValues();
          $(this).closest('.autocomplete-list').hide();
          $this.input_text.focus();

          vendorFilter.submitForm();
        });
      },
      saveSelectedData: function(item){
        let $this = locationFinder,
            itm = $(item),
            type = itm.data('type'),
            value = itm.data('value'),
            title = itm.find('.autocomplete-list-item__title').html();

        const isExist = $this.selection.find('li.autocomplete-field_selection-item').filter((ind, el) => $(el).data('value') === value && $(el).data('type') === type ).length;
        if (isExist) {
          return false;
        }

        $this.selection.append(`<li class="autocomplete-field_selection-item" data-type="${type}" data-value="${value}">${title}<span class="autocomplete-field_selection-remove">x</span></li>`);

        $this.input_text.val('').attr('placeholder', '');
        $this.calculateValues();
        return true;
      },
      calculateValues: function(){
        let $this = locationFinder;
        let acc = [];

        $this.selection.find('.autocomplete-field_selection-item').map((ind, el) => {
          if (el){
            acc.push(`${$(el).data('type')}|${$(el).data('value')}`);
          }
        });

        $this.input_data.val(acc.join(','));

      },
      processInput: function(input) {
        var s = $(input).val(), html, $this = locationFinder, str = $.trim(s);
        if (str.length === 0) {
          $this.autocompleteList().html('');
          return;
        }

        var rows = $this.filterDataRows(str);
        if (rows.length === 0) {
          html = $this.getNoResultsRowHtml();
        } else {
          html = $this.renderRowItems(rows);
        }
        $this.autocompleteList().html(html).show();
      },
      populateInput: function(){
        const val = locationFinder.input_data.val();
        const st = this.getUrlParameter('study_type');

        locationFinder.selection.html('');
        val.split(',').map(el => {
          const d = el.split('|');
          const type = d[0];
          const value = d[1];

          const valRow = locationsData[st].filter(function (data) {
            return data.id == value;
          });

          if (valRow.length > 0) {
            locationFinder.selection.append(`<li class="autocomplete-field_selection-item" data-type="${type}" data-value="${value}">${valRow[0].title}<span class="autocomplete-field_selection-remove">x</span></li>`);
          }
        });
      },
      renderRowItems: function(items){
        var html = '';
        items.map(function (item) {
          html += locationFinder.getRowHtml(item);
        });
        return html;
      },
      filterDataRows: function(value){
        let study_id = $('#filter_study_type').val();
        return locationsData[study_id].filter(function (data) {
          return data.title.toUpperCase().includes(value.toUpperCase());
        });
      },
      getRowHtml: function (data) {
        let subtitle = '';
        if (data.subtitle !== '') {
          subtitle = '<div class="autocomplete-list-item__subtitle">' + data.subtitle + '</div>';
        }

        return '<li class="autocomplete-list-item autocomplete-list-item_padding-small" data-type="' + data.type  + '" data-value="' + data.id  + '">' +
          '    <div class="autocomplete-list-item__title-row">' +
          '        <div class="autocomplete-list-item__title">' + data.title + '</div>' +
          subtitle +
          '    </div>' +
          '</li>';
      },
      getNoResultsRowHtml: function () {
        return '<li class="autocomplete-list-item autocomplete-list-item_no-result autocomplete-list-item_padding-small">' +
          '    <div class="autocomplete-list-item__title-row">' +
          '        <div class="autocomplete-list-item__title">No results</div>' +
          '    </div>' +
          '</li>';
      },
      getUrlParameter: function(sParam){
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split('=');

          if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
          }
        }
      }
    };
    let vendorFilter = {
      init: function(){
        $('#filter_study_type').on('change', function (e) {
          var val = $(this).val();
          vendorFilter.populateProgramOptions(val);
          vendorFilter.submitForm();
        });
        $('input[name=filter_processing_time]').on('change', function(){
          vendorFilter.submitForm();
        });
        $('#filter_program').on('change', function (e) {
          vendorFilter.submitForm();
        });
        $('#load-more').on('click', this.loadMoreHandler);
        $('.emoji-search-wrapper a').on('click', function (e){
          e.preventDefault();
          $(this).toggleClass('active');

          const value = $(this).data('id');
          let existingValues = $('#emoji-value').val() != '' ? $('#emoji-value').val().split(',') : [];
          const res = existingValues.filter(id => id == value);
          if (res.length === 0) {
            existingValues.push(value);
          } else {
            existingValues = existingValues.filter(id => id != value)
          }
          $('#emoji-value').val(existingValues.join(','));

          vendorFilter.submitForm();
        })

        $('input[name=sort_order_]').change(function() {
          vendorFilter.submitForm();
          $('.close-filter').click();

          $('.order-select').html($(this).data('title'));
        });

        // Toggle Filters slide-up
        $('#toggle-filters-panel').on('click', function() {
          $('.search-filters').slideToggle(400, function () {
            let $this = $('#toggle-filters-panel')
            if ($this.hasClass('closed')) {
                $this.removeClass('closed').addClass('open').html($this.data('open-text'))
            } else if($this.hasClass('open')) {
              $this.removeClass('open').addClass('closed').html($this.data('closed-text'))
            }
          });
        });

        // Toggle filter form-groups close/open on CHEVRON click
        $('.search-filters .form-group > i').on('click', function() {
          $(this).toggleClass('closed');
          $(this).parent('.form-group').find('.single-filter-content').slideToggle('fast');
        });

        // Toggle filter form-groups close/open on LABEL click
        $('.search-filters > .form-group.filter-toggle .form-label').on('click', function() {
          $(this).closest('.form-group').toggleClass('closed');
          $(this).parent('.form-group').find('.single-filter-content').slideToggle('fast');
        });

        // Toggle complex filters with Yes/No (1/0)
        $(document).on('change', 'input[name=filter_language_exams]', function(){
          if ( $('input[name=filter_language_exams]:checked').val() === '1') {
            $('.lang-sliders-group').slideDown();
          } else {
            $('.lang-sliders-group').slideUp();
          }
        });

        $(document).on('change', 'input[name=filter_entrance_exams]', function(){
          if ( $('input[name=filter_entrance_exams]:checked').val() === '1') {
            $('.entrance-sliders-group').slideDown();
          } else {
            $('.entrance-sliders-group').slideUp();
          }
        });

        function displaySliderData(from_field, to_field, from, to){
          $(from_field).html(from)
          $(to_field).html(to)
        }

        // Data for Filter Sliders with default values
        const prs = '.price-range-slider';
        $(prs).ionRangeSlider({
          type: 'double',
          min: 0,
          max: 60000,
          from: 0,
          to: 60000,
          step: 500,
          hide_min_max: true,
          hide_from_to: true,
          onStart: function () {
            $(`<div class="slider-data-wrapper"><div class="slider-data ${prs.substr(1)}-data-from"></div><div class="slider-data ${prs.substr(1)}-data-to"></div></div>`).insertAfter($(prs));
          },
          onChange: function () {
            let val = $(prs).data('ionRangeSlider');
            displaySliderData(prs + '-data-from', prs + '-data-to', vendorFilter.formatNumber(val.result.from), vendorFilter.formatNumber(val.result.to))
          },
          onUpdate: function () {
            let val = $(prs).data('ionRangeSlider');
            displaySliderData(prs + '-data-from', prs + '-data-to', vendorFilter.formatNumber(val.result.from), vendorFilter.formatNumber(val.result.to))
          },
          onFinish: function () {
            vendorFilter.submitForm();
          },
        });
        var price_range = $(prs).data('ionRangeSlider');

        const gs1 = '.gpa-slider-1';
        $(gs1).ionRangeSlider({
          type: 'double',
          min: 0,
          max: 4,
          from: 0,
          to: 4,
          step: 0.1,
          hide_min_max: true,
          hide_from_to: true,
          onStart: function () {
            $(`<div class="slider-data-wrapper"><div class="slider-data ${gs1.substr(1)}-data-from"></div><div class="slider-data ${gs1.substr(1)}-data-to"></div></div>`).insertAfter($(gs1));
          },
          onChange: function () {
            let val = $(gs1).data('ionRangeSlider');
            displaySliderData(gs1 + '-data-from', gs1 + '-data-to', val.result.from, val.result.to)
          },
          onUpdate: function () {
            let val = $(gs1).data('ionRangeSlider');
            displaySliderData(gs1 + '-data-from', gs1 + '-data-to', val.result.from, val.result.to)
          },
          onFinish: function (data) {
            vendorFilter.submitForm();
          }
        });
        var gpa_slider1 = $(gs1).data('ionRangeSlider');

        const gs2 = '.gpa-slider-2';
        $(gs2).ionRangeSlider({
          type: 'double',
          min: 0,
          max: 100,
          from: 1,
          to: 100,
          step: 1,
          hide_min_max: true,
          hide_from_to: true,
          onStart: function () {
            $(`<div class="slider-data-wrapper"><div class="slider-data ${gs2.substr(1)}-data-from"></div><div class="slider-data ${gs2.substr(1)}-data-to"></div></div>`).insertAfter($(gs2));
          },
          onChange: function () {
            let val = $(gs2).data('ionRangeSlider');
            displaySliderData(gs2 + '-data-from', gs2 + '-data-to', val.result.from, val.result.to)
          },
          onUpdate: function () {
            let val = $(gs2).data('ionRangeSlider');
            displaySliderData(gs2 + '-data-from', gs2 + '-data-to', val.result.from, val.result.to)
          },
          onFinish: function (data) {
            vendorFilter.submitForm();
          }
        });
        var gpa_slider2 = $(gs2).data('ionRangeSlider');

        const lts = '.lang-toefl-slider';
        $(lts).ionRangeSlider({
          type: 'double',
          min: 0,
          max: 120,
          from: 0,
          to: 120,
          step: 1,
          hide_min_max: true,
          hide_from_to: true,
          onStart: function () {
            $(`<div class="slider-data-wrapper"><div class="slider-data ${lts.substr(1)}-data-from"></div><div class="slider-data ${lts.substr(1)}-data-to"></div></div>`).insertAfter($(lts));
          },
          onChange: function () {
            let val = $(lts).data('ionRangeSlider');
            displaySliderData(lts + '-data-from', lts + '-data-to', val.result.from, val.result.to)
          },
          onUpdate: function () {
            let val = $(lts).data('ionRangeSlider');
            displaySliderData(lts + '-data-from', lts + '-data-to', val.result.from, val.result.to)
          },
          onFinish: function (data) {
            vendorFilter.submitForm();
          }
        });
        var lang_toefl_slider = $(lts).data('ionRangeSlider');

        const lis = '.lang-ielts-slider';
        $(lis).ionRangeSlider({
          type: 'double',
          min: 0,
          max: 9,
          from: 0,
          to: 9,
          step: 0.5,
          hide_min_max: true,
          hide_from_to: true,
          onStart: function () {
            $(`<div class="slider-data-wrapper"><div class="slider-data ${lis.substr(1)}-data-from"></div><div class="slider-data ${lis.substr(1)}-data-to"></div></div>`).insertAfter($(lis));
          },
          onChange: function () {
            let val = $(lis).data('ionRangeSlider');
            displaySliderData(lis + '-data-from', lis + '-data-to', val.result.from, val.result.to)
          },
          onUpdate: function () {
            let val = $(lis).data('ionRangeSlider');
            displaySliderData(lis + '-data-from', lis + '-data-to', val.result.from, val.result.to)
          },
          onFinish: function (data) {
            vendorFilter.submitForm();
          }
        });
        var lang_ielts_slider = $(lis).data('ionRangeSlider');

        const lips = '.lang-itep-slider';
        $(lips).ionRangeSlider({
          type: 'double',
          min: 0,
          max: 6,
          from: 0,
          to: 6,
          step: 0.5,
          hide_min_max: true,
          hide_from_to: true,
          onStart: function () {
            $(`<div class="slider-data-wrapper"><div class="slider-data ${lips.substr(1)}-data-from"></div><div class="slider-data ${lips.substr(1)}-data-to"></div></div>`).insertAfter($(lips));
          },
          onChange: function () {
            let val = $(lips).data('ionRangeSlider');
            displaySliderData(lips + '-data-from', lips + '-data-to', val.result.from, val.result.to)
          },
          onUpdate: function () {
            let val = $(lips).data('ionRangeSlider');
            displaySliderData(lips + '-data-from', lips + '-data-to', val.result.from, val.result.to)
          },
          onFinish: function (data) {
            vendorFilter.submitForm();
          }
        });
        var lang_itep_slider = $(lips).data('ionRangeSlider');

        const lds = '.lang-duolingo-slider';
        $(lds).ionRangeSlider({
          type: 'double',
          min: 10,
          max: 160,
          from: 10,
          to: 160,
          step: 5,
          hide_min_max: true,
          hide_from_to: true,
          onStart: function () {
            $(`<div class="slider-data-wrapper"><div class="slider-data ${lds.substr(1)}-data-from"></div><div class="slider-data ${lds.substr(1)}-data-to"></div></div>`).insertAfter($(lds));
          },
          onChange: function () {
            let val = $(lds).data('ionRangeSlider');
            displaySliderData(lds + '-data-from', lds + '-data-to', val.result.from, val.result.to)
          },
          onUpdate: function () {
            let val = $(lds).data('ionRangeSlider');
            displaySliderData(lds + '-data-from', lds + '-data-to', val.result.from, val.result.to)
          },
          onFinish: function (data) {
            vendorFilter.submitForm();
          }
        });
        var lang_duolingo_slider = $(lds).data('ionRangeSlider');

        const lpts = '.lang-pte-slider';
        $(lpts).ionRangeSlider({
          type: 'double',
          min: 10,
          max: 90,
          from: 10,
          to: 90,
          step: 1,
          hide_min_max: true,
          hide_from_to: true,
          onStart: function () {
            $(`<div class="slider-data-wrapper"><div class="slider-data ${lpts.substr(1)}-data-from"></div><div class="slider-data ${lpts.substr(1)}-data-to"></div></div>`).insertAfter($(lpts));
          },
          onChange: function () {
            let val = $(lpts).data('ionRangeSlider');
            displaySliderData(lpts + '-data-from', lpts + '-data-to', val.result.from, val.result.to)
          },
          onUpdate: function () {
            let val = $(lpts).data('ionRangeSlider');
            displaySliderData(lpts + '-data-from', lpts + '-data-to', val.result.from, val.result.to)
          },
          onFinish: function (data) {
            vendorFilter.submitForm();
          }
        });
        var lang_pte_slider = $(lpts).data('ionRangeSlider');

        const ess = '.exams-sat-slider';
        $(ess).ionRangeSlider({
          type: 'double',
          min: 400,
          max: 1600,
          from: 400,
          to: 1600,
          step: 10,
          hide_min_max: true,
          hide_from_to: true,
          onStart: function () {
            $(`<div class="slider-data-wrapper"><div class="slider-data ${ess.substr(1)}-data-from"></div><div class="slider-data ${ess.substr(1)}-data-to"></div></div>`).insertAfter($(ess));
          },
          onChange: function () {
            let val = $(ess).data('ionRangeSlider');
            displaySliderData(ess + '-data-from', ess + '-data-to', val.result.from, val.result.to)
          },
          onUpdate: function () {
            let val = $(ess).data('ionRangeSlider');
            displaySliderData(ess + '-data-from', ess + '-data-to', val.result.from, val.result.to)
          },
          onFinish: function (data) {
            vendorFilter.submitForm();
          }
        });
        var exams_sat_slider = $(ess).data('ionRangeSlider');

        const eas = '.exams-act-slider';
        $(eas).ionRangeSlider({
          type: 'double',
          min: 1,
          max: 36,
          from: 1,
          to: 36,
          step: 1,
          hide_min_max: true,
          hide_from_to: true,
          onStart: function () {
            $(`<div class="slider-data-wrapper"><div class="slider-data ${eas.substr(1)}-data-from"></div><div class="slider-data ${eas.substr(1)}-data-to"></div></div>`).insertAfter($(eas));
          },
          onChange: function () {
            let val = $(eas).data('ionRangeSlider');
            displaySliderData(eas + '-data-from', eas + '-data-to', val.result.from, val.result.to)
          },
          onUpdate: function () {
            let val = $(eas).data('ionRangeSlider');
            displaySliderData(eas + '-data-from', eas + '-data-to', val.result.from, val.result.to)
          },
          onFinish: function (data) {
            vendorFilter.submitForm();
          }
        });
        var exams_act_slider = $(eas).data('ionRangeSlider');

        const eis = '.exams-igcse-slider';
        $(eis).ionRangeSlider({
          type: 'double',
          min: 1,
          max: 9,
          from: 1,
          to: 9,
          step: 1,
          hide_min_max: true,
          hide_from_to: true,
          onStart: function () {
            $(`<div class="slider-data-wrapper"><div class="slider-data ${eis.substr(1)}-data-from"></div><div class="slider-data ${eis.substr(1)}-data-to"></div></div>`).insertAfter($(eis));
          },
          onChange: function () {
            let val = $(eis).data('ionRangeSlider');
            displaySliderData(eis + '-data-from', eis + '-data-to', val.result.from, val.result.to)
          },
          onUpdate: function () {
            let val = $(eis).data('ionRangeSlider');
            displaySliderData(eis + '-data-from', eis + '-data-to', val.result.from, val.result.to)
          },
          onFinish: function (data) {
            vendorFilter.submitForm();
          }
        });
        var exams_igcse_slider = $(eis).data('ionRangeSlider');

        const egs = '.exams-gmat-slider';
        $(egs).ionRangeSlider({
          type: 'double',
          min: 200,
          max: 800,
          from: 200,
          to: 800,
          step: 10,
          hide_min_max: true,
          hide_from_to: true,
          onStart: function () {
            $(`<div class="slider-data-wrapper"><div class="slider-data ${egs.substr(1)}-data-from"></div><div class="slider-data ${egs.substr(1)}-data-to"></div></div>`).insertAfter($(egs));
          },
          onChange: function () {
            let val = $(egs).data('ionRangeSlider');
            displaySliderData(egs + '-data-from', egs + '-data-to', val.result.from, val.result.to)
          },
          onUpdate: function () {
            let val = $(egs).data('ionRangeSlider');
            displaySliderData(egs + '-data-from', egs + '-data-to', val.result.from, val.result.to)
          },
          onFinish: function (data) {
            vendorFilter.submitForm();
          }
        });
        var exams_gmat_slider = $(egs).data('ionRangeSlider');

        const egrs = '.exams-gre-slider';
        $(egrs).ionRangeSlider({
          type: 'double',
          min: 130,
          max: 170,
          from: 130,
          to: 170,
          step: 1,
          hide_min_max: true,
          hide_from_to: true,
          onStart: function () {
            $(`<div class="slider-data-wrapper"><div class="slider-data ${egrs.substr(1)}-data-from"></div><div class="slider-data ${egrs.substr(1)}-data-to"></div></div>`).insertAfter($(egrs));
          },
          onChange: function () {
            let val = $(egrs).data('ionRangeSlider');
            displaySliderData(egrs + '-data-from', egrs + '-data-to', val.result.from, val.result.to)
          },
          onUpdate: function () {
            let val = $(egrs).data('ionRangeSlider');
            displaySliderData(egrs + '-data-from', egrs + '-data-to', val.result.from, val.result.to)
          },
          onFinish: function (data) {
            vendorFilter.submitForm();
          }
        });
        var exams_gre_slider = $(egrs).data('ionRangeSlider');

        // Set / reset all slider-filters - http://ionden.com/a/plugins/ion.rangeSlider/api.html
        function resetSliderFilters(){
          price_range.reset();
          gpa_slider1.reset();
          gpa_slider2.reset();
          lang_toefl_slider.reset();
          lang_ielts_slider.reset();
          lang_itep_slider.reset();
          lang_duolingo_slider.reset();
          lang_pte_slider.reset();
          exams_sat_slider.reset();
          exams_act_slider.reset();
          exams_igcse_slider.reset();
          exams_gmat_slider.reset();
          exams_gre_slider.reset();
        }

        // Clear all filters
        $(document).on('click', '.filter-clear', function(e){
          e.preventDefault();
          $('.search-filters input[type="checkbox"]').prop('checked', false);
          $('.search-filters input[type="radio"]').prop('checked', false);
          $('input[name=filter_language_exams][value="0"]').prop('checked', true);
          $('input[name=filter_entrance_exams][value="0"]').prop('checked', true);
          locationFinder.input_data.val('');
          locationFinder.populateInput();
          $('.filter-program-search-field').val('');
          $('#location').val('');
          resetSliderFilters();

          $('#emoji-value').val('');
          $('.emoji-search-wrapper a').removeClass('active');

          vendorFilter.programShowSelected();
          vendorFilter.submitForm();

          $('.js_collapsed').addClass('closed').find('.single-filter-content').hide();
        });

        $(document).on('click', '#subFilterSortBtn, .close-filter', function(e){
          e.preventDefault();
          $('#sub-filter-sort .dropdown-menu').slideToggle('fast');
          $('#subFilterSortBtn').toggleClass('open');
        });

        $('.search-filters input[type="checkbox"]').change(function() {
          vendorFilter.submitForm();
        });

        vendorFilter.toggleSingleFilter ('.filter-toggle.js_collapsed');

        this.parseUrl();
        this.loadVendors('replace', false);
        this.saveCurrentUrl();
      },
      animatetoTop: function() {
        setTimeout(() => { $('html, body').animate({ scrollTop: $('.search-toolbar').offset().top - 20}, 500, 'linear') }, 500);
      },
      loadMoreHandler: function(e){
        e.preventDefault();
        if (isLoading === false) {
          vendorFilter.loadVendors('append', false);
        }
      },
      submitForm: function(e){
        vendorFilter.animatetoTop();
        if (e) {
          e.preventDefault();
        }
        var filter_emoji = $('#emoji-value').val();
        var filter_study_type = $('#filter_study_type').val();
        var filter_show_eligible = $('#filter_show_eligible').val();
        var filter_order = $('input:radio[name=sort_order_]:checked').data('value');

        var filter_total_enrolment = [];
        $.each($("input[name='filter_total_enrolment']:checked"), function(){
          filter_total_enrolment.push($(this).val());
        });

        var filter_student_enrolment = [];
        $.each($("input[name='filter_student_enrolment']:checked"), function(){
          filter_student_enrolment.push($(this).val());
        });

        var filter_environment = [];
        $.each($("input[name='filter_environment']:checked"), function(){
          filter_environment.push($(this).val());
        });

        var filter_climate = [];
        $.each($("input[name='filter_climate']:checked"), function(){
          filter_climate.push($(this).val());
        });

        var filter_accommodation = [];
        $.each($("input[name='filter_accommodation']:checked"), function(){
          filter_accommodation.push($(this).val());
        });

        var filter_online_program = [];
        $.each($("input[name='filter_online_program']:checked"), function(){
          filter_online_program.push($(this).val());
        });

        var filter_sport_teams = [];
        $.each($("input[name='filter_sport_teams']:checked"), function(){
          filter_sport_teams.push($(this).val());
        });

        var filter_sport_leagues = [];
        $.each($("input[name='filter_sport_leagues']:checked"), function(){
          filter_sport_leagues.push($(this).val());
        });

        var filter_clubs = [];
        $.each($("input[name='filter_clubs']:checked"), function(){
          filter_clubs.push($(this).val());
        });

        var filter_gender_restrictions = [];
        $.each($("input[name='filter_gender_restrictions']:checked"), function(){
          filter_gender_restrictions.push($(this).val());
        });

        var filter_religious_affiliation = [];
        $.each($("input[name='filter_religious_affiliation']:checked"), function(){
          filter_religious_affiliation.push($(this).val());
        });

        var filter_language_instruction = [];
        $.each($("input[name='filter_language_instruction']:checked"), function(){
          filter_language_instruction.push($(this).val());
        });

        var filter_learning_disability = [];
        $.each($("input[name='filter_learning_disability']:checked"), function(){
          filter_learning_disability.push($(this).val());
        });

        var filter_location = locationFinder.input_data.val();

        var filter_program = [];
        $.each($("input[name='filter_program']:checked"), function(){
          filter_program.push($(this).val());
        });

        var filter_price_range = $(".price-range-slider").data("ionRangeSlider");
        var filter_ranked = $('input[name=filter_ranked]:checked').length;
        var student_loans = $('input[name=student_loans]:checked').length;
        var filter_gap_year = $('input[name=filter_gap_year]:checked').length;

        var filter_business_type = [];
        $.each($("input[name='filter_business_type']:checked"), function(){
          filter_business_type.push($(this).val());
        });

        var grade_gpa_scale1_range = $('.gpa-slider-1').data('ionRangeSlider');
        var grade_gpa_scale1_data = [grade_gpa_scale1_range.result.from, grade_gpa_scale1_range.result.to];
        if ($('input[name=gpa_scale]:checked').val() !== '1') {
          grade_gpa_scale1_data = '';
        }

        var grade_gpa_scale2_range = $('.gpa-slider-2').data('ionRangeSlider');
        var grade_gpa_scale2_data = [grade_gpa_scale2_range.result.from, grade_gpa_scale2_range.result.to];
        if ($('input[name=gpa_scale]:checked').val() !== '2') {
          grade_gpa_scale2_data = '';
        }

        var lang_toefl_range = $('.lang-toefl-slider').data('ionRangeSlider');
        var lang_toefl_data = '';
        if ($('input[name=filter_language_exams]:checked').val() === '1' && $('input[name=lang_scale]:checked').val() === 'toefl') {
          lang_toefl_data = [lang_toefl_range.result.from, lang_toefl_range.result.to];
        }

        var lang_ielts_range = $('.lang-ielts-slider').data('ionRangeSlider');
        var lang_ielts_data = '';
        if ($('input[name=filter_language_exams]:checked').val() === '1' && $('input[name=lang_scale]:checked').val() === 'ielts') {
          lang_ielts_data = [lang_ielts_range.result.from, lang_ielts_range.result.to];
        }

        var lang_itep_range = $('.lang-itep-slider').data('ionRangeSlider');
        var lang_itep_data = '';
        if ($('input[name=filter_language_exams]:checked').val() === '1' && $('input[name=lang_scale]:checked').val() === 'itep') {
          lang_itep_data = [lang_itep_range.result.from, lang_itep_range.result.to];
        }

        var lang_duolingo_range = $('.lang-duolingo-slider').data('ionRangeSlider');
        var lang_duolingo_data = '';
        if ($('input[name=filter_language_exams]:checked').val() === '1' && $('input[name=lang_scale]:checked').val() === 'duolingo') {
          lang_duolingo_data = [lang_duolingo_range.result.from, lang_duolingo_range.result.to];
        }

        var lang_pte_range = $('.lang-pte-slider').data('ionRangeSlider');
        var lang_pte_data = '';
        if ($('input[name=filter_language_exams]:checked').val() === '1' && $('input[name=lang_scale]:checked').val() === 'pte') {
          lang_pte_data = [lang_pte_range.result.from, lang_pte_range.result.to];
        }

        var exams_sat_range = $('.exams-sat-slider').data('ionRangeSlider');
        var exams_sat_data = '';
        if ($('input[name=filter_entrance_exams]:checked').val() === '1' && $('input[name=entrance_scale]:checked').val() === 'sat') {
          exams_sat_data = [exams_sat_range.result.from, exams_sat_range.result.to];
        }

        var exams_act_range = $('.exams-act-slider').data('ionRangeSlider');
        var exams_act_data = '';
        if ($('input[name=filter_entrance_exams]:checked').val() === '1' && $('input[name=entrance_scale]:checked').val() === 'act') {
          exams_act_data = [exams_act_range.result.from, exams_act_range.result.to];
        }

        var exams_igcse_range = $('.exams-igcse-slider').data('ionRangeSlider');
        var exams_igcse_data = '';
        if ($('input[name=filter_entrance_exams]:checked').val() === '1' && $('input[name=entrance_scale]:checked').val() === 'igcse') {
          exams_igcse_data = [exams_igcse_range.result.from, exams_igcse_range.result.to];
        }

        var exams_gmat_range = $('.exams-gmat-slider').data('ionRangeSlider');
        var exams_gmat_data = '';
        if ($('input[name=filter_entrance_exams]:checked').val() === '1' && $('input[name=entrance_scale]:checked').val() === 'gmat') {
          exams_gmat_data = [exams_gmat_range.result.from, exams_gmat_range.result.to];
        }

        var exams_gre_range = $('.exams-gre-slider').data('ionRangeSlider');
        var exams_gre_data = '';
        if ($('input[name=filter_entrance_exams]:checked').val() === '1' && $('input[name=entrance_scale]:checked').val() === 'gre') {
          exams_gre_data = [exams_gre_range.result.from, exams_gre_range.result.to];
        }

        var filter_processing_time = [];
        $.each($('input[name=filter_processing_time]:checked'), function(){
          filter_processing_time.push($(this).val());
        });
        var filter = {
          emoji: filter_emoji,
          program: filter_program,
          total_enrolment: filter_total_enrolment,
          price_range: [filter_price_range.result.from, filter_price_range.result.to],
          grade_gpa_scale1: grade_gpa_scale1_data,
          grade_gpa_scale2: grade_gpa_scale2_data,
          lang_toefl_range: lang_toefl_data,
          lang_ielts_range: lang_ielts_data,
          lang_itep_range: lang_itep_data,
          lang_duolingo_range: lang_duolingo_data,
          lang_pte_range: lang_pte_data,
          exams_sat_range: exams_sat_data,
          exams_act_range: exams_act_data,
          exams_igcse_range: exams_igcse_data,
          exams_gmat_range: exams_gmat_data,
          exams_gre_range: exams_gre_data,
          student_enrolment: filter_student_enrolment,
          ranked: filter_ranked ? 1 : '',
          student_loans: student_loans ? 1 : '',
          environment: filter_environment,
          climate: filter_climate,
          accommodation: filter_accommodation,
          online_program: filter_online_program,
          sport_teams: filter_sport_teams,
          sport_leagues: filter_sport_leagues,
          clubs: filter_clubs,
          gender_restrictions: filter_gender_restrictions,
          religious_affiliation: filter_religious_affiliation,
          language_instruction: filter_language_instruction,
          learning_disability: filter_learning_disability,
          gap_year: filter_gap_year ? 1 : '',
          study_type: filter_study_type,
          show_eligible: filter_show_eligible,
          location: filter_location,
          order: filter_order,
          business_type: filter_business_type,
          processing_time: filter_processing_time
        };

        store('vendor-filter', filter);
        vendorFilter.generateUrl();
        vendorFilter.loadVendors('replace', true);
      },
      generateUrl: function(){
        var filter = store('vendor-filter'), out = {};

        for (var prop in filter) {
          if (Object.prototype.hasOwnProperty.call(filter, prop)) {
            var v;
            if (Array.isArray(filter[prop])) {
              v = filter[prop].join(',')
            } else {
              v = filter[prop];
            }
            out[prop] = v;
          }
        }

        $.each(out, function(k, v) {
          if(v == ""){
            delete out[k];
          }
        });

        // make url
        var url = $.param(out);
        // console.log(decodeURIComponent(url))
        // window.location.host
        this.changeUrl('', '?' + url);
      },
      changeUrl: function(title, url){
        if (typeof (history.pushState) != "undefined") {
          var obj = { Title: title, Url: url };
          history.pushState(obj, obj.Title, obj.Url);
        } else {
          console.log("Browser does not support HTML5.");
        }
        this.saveCurrentUrl();
      },
      parseUrl: function(){
        var filter_emoji = this.getUrlParameter('emoji'),
          filter_program = this.getUrlParameter('program'),
          filter_total_enrolment = this.getUrlParameter('total_enrolment'),
          filter_price_range = this.getUrlParameter('price_range'),
          filter_grade_gpa_scale1 = this.getUrlParameter('grade_gpa_scale1'),
          filter_grade_gpa_scale2 = this.getUrlParameter('grade_gpa_scale2'),
          filter_lang_toefl_range = this.getUrlParameter('lang_toefl_range'),
          filter_lang_ielts_range = this.getUrlParameter('lang_ielts_range'),
          filter_lang_itep_range = this.getUrlParameter('lang_itep_range'),
          filter_lang_duolingo_range = this.getUrlParameter('lang_duolingo_range'),
          filter_lang_pte_range = this.getUrlParameter('lang_pte_range'),
          filter_exams_sat_range = this.getUrlParameter('exams_sat_range'),
          filter_exams_act_range = this.getUrlParameter('exams_act_range'),
          filter_exams_igcse_range = this.getUrlParameter('exams_igcse_range'),
          filter_exams_gmat_range = this.getUrlParameter('exams_gmat_range'),
          filter_exams_gre_range = this.getUrlParameter('exams_gre_range'),
          filter_student_enrolment = this.getUrlParameter('student_enrolment'),
          filter_ranked = this.getUrlParameter('ranked'),
          student_loans = this.getUrlParameter('student_loans'),
          filter_online_program = this.getUrlParameter('online_program'),
          filter_environment = this.getUrlParameter('environment'),
          filter_climate = this.getUrlParameter('climate'),
          filter_accommodation = this.getUrlParameter('accommodation'),
          filter_sport_teams = this.getUrlParameter('sport_teams'),
          filter_sport_leagues = this.getUrlParameter('sport_leagues'),
          filter_clubs = this.getUrlParameter('clubs'),
          filter_gender_restrictions = this.getUrlParameter('gender_restrictions'),
          filter_religious_affiliation = this.getUrlParameter('religious_affiliation'),
          filter_language_instruction = this.getUrlParameter('language_instruction'),
          filter_learning_disability = this.getUrlParameter('learning_disability'),
          filter_gap_year = this.getUrlParameter('gap_year'),
          filter_study_type = this.getUrlParameter('study_type'),
          filter_show_eligible = this.getUrlParameter('show_eligible'),
          filter_location = this.getUrlParameter('location'),
          filter_location_type = this.getUrlParameter('location_type'),
          filter_business_type = this.getUrlParameter('business_type'),
          filter_order = this.getUrlParameter('order'),
          filter_processing_time = this.getUrlParameter('processing_time');

        var filter_price_range_val = undefined;
        if (filter_price_range !== undefined) {
          filter_price_range_val = filter_price_range.split(',');
        } else {
          var sliderData = $(".price-range-slider").data("ionRangeSlider");
          filter_price_range_val = [sliderData.options.from, sliderData.options.to];
        }

        var filter_grade_gpa_scale1_val = undefined;
        if (filter_grade_gpa_scale1 !== undefined) {
          filter_grade_gpa_scale1_val = filter_grade_gpa_scale1.split(',');
        }

        var filter_grade_gpa_scale2_val = undefined;
        if (filter_grade_gpa_scale2 !== undefined) {
          filter_grade_gpa_scale2_val = filter_grade_gpa_scale2.split(',');
        }

        var filter_lang_toefl_val = undefined;
        if (filter_lang_toefl_range !== undefined) {
          filter_lang_toefl_val = filter_lang_toefl_range.split(',');
        }

        var filter_lang_ielts_val = undefined;
        if (filter_lang_ielts_range !== undefined) {
          filter_lang_ielts_val = filter_lang_ielts_range.split(',');
        }

        var filter_lang_itep_val = undefined;
        if (filter_lang_itep_range !== undefined) {
          filter_lang_itep_val = filter_lang_itep_range.split(',');
        }

        var filter_lang_duolingo_val = undefined;
        if (filter_lang_duolingo_range !== undefined) {
          filter_lang_duolingo_val = filter_lang_duolingo_range.split(',');
        }

        var filter_lang_pte_val = undefined;
        if (filter_lang_pte_range !== undefined) {
          filter_lang_pte_val = filter_lang_pte_range.split(',');
        }

        var filter_exams_sat_val = undefined;
        if (filter_exams_sat_range !== undefined) {
          filter_exams_sat_val = filter_exams_sat_range.split(',');
        }

        var filter_exams_act_val = undefined;
        if (filter_exams_act_range !== undefined) {
          filter_exams_act_val = filter_exams_act_range.split(',');
        }

        var filter_exams_igcse_val = undefined;
        if (filter_exams_igcse_range !== undefined) {
          filter_exams_igcse_val = filter_exams_igcse_range.split(',');
        }

        var filter_exams_gmat_val = undefined;
        if (filter_exams_gmat_range !== undefined) {
          filter_exams_gmat_val = filter_exams_gmat_range.split(',');
        }

        var filter_exams_gre_val = undefined;
        if (filter_exams_gre_range !== undefined) {
          filter_exams_gre_val = filter_exams_gre_range.split(',');
        }

        var filter = {
          emoji: filter_emoji === undefined ? '' : filter_emoji,
          program: filter_program === undefined ? '' : filter_program.split(','),
          study_type: filter_study_type === undefined ? this.getDefaultStudyTypeValue() : filter_study_type,
          show_eligible: filter_show_eligible === undefined ? '' : filter_show_eligible,
          total_enrolment: filter_total_enrolment === undefined ? '' : filter_total_enrolment.split(','),
          price_range: filter_price_range_val === undefined ? '' : [filter_price_range_val[0], filter_price_range_val[1]],
          grade_gpa_scale1: filter_grade_gpa_scale1_val === undefined ? '' : [filter_grade_gpa_scale1_val[0], filter_grade_gpa_scale1_val[1]],
          grade_gpa_scale2: filter_grade_gpa_scale2_val === undefined ? '' : [filter_grade_gpa_scale2_val[0], filter_grade_gpa_scale2_val[1]],
          lang_toefl_range: filter_lang_toefl_val === undefined ? '' : [filter_lang_toefl_val[0], filter_lang_toefl_val[1]],
          lang_ielts_range: filter_lang_ielts_val === undefined ? '' : [filter_lang_ielts_val[0], filter_lang_ielts_val[1]],
          lang_itep_range: filter_lang_itep_val === undefined ? '' : [filter_lang_itep_val[0], filter_lang_itep_val[1]],
          lang_duolingo_range: filter_lang_duolingo_val === undefined ? '' : [filter_lang_duolingo_val[0], filter_lang_duolingo_val[1]],
          lang_pte_range: filter_lang_pte_val === undefined ? '' : [filter_lang_pte_val[0], filter_lang_pte_val[1]],
          exams_sat_range: filter_exams_sat_val === undefined ? '' : [filter_exams_sat_val[0], filter_exams_sat_val[1]],
          exams_act_range: filter_exams_act_val === undefined ? '' : [filter_exams_act_val[0], filter_exams_act_val[1]],
          exams_igcse_range: filter_exams_igcse_val === undefined ? '' : [filter_exams_igcse_val[0], filter_exams_igcse_val[1]],
          exams_gmat_range: filter_exams_gmat_val === undefined ? '' : [filter_exams_gmat_val[0], filter_exams_gmat_val[1]],
          exams_gre_range: filter_exams_gre_val === undefined ? '' : [filter_exams_gre_val[0], filter_exams_gre_val[1]],
          student_enrolment: filter_student_enrolment === undefined ? '' : filter_student_enrolment.split(','),
          ranked: filter_ranked === undefined ? '' : filter_ranked,
          student_loans: student_loans === undefined ? '' : student_loans,
          environment: filter_environment === undefined ? '' : filter_environment.split(','),
          climate: filter_climate === undefined ? '' : filter_climate.split(','),
          accommodation: filter_accommodation === undefined ? '' : filter_accommodation.split(','),
          online_program: filter_online_program === undefined ? '' : filter_online_program.split(','),
          sport_teams: filter_sport_teams === undefined ? '' : filter_sport_teams.split(','),
          sport_leagues: filter_sport_leagues === undefined ? '' : filter_sport_leagues.split(','),
          clubs: filter_clubs === undefined ? '' : filter_clubs.split(','),
          gender_restrictions: filter_gender_restrictions === undefined ? '' : filter_gender_restrictions.split(','),
          religious_affiliation: filter_religious_affiliation === undefined ? '' : filter_religious_affiliation.split(','),
          language_instruction: filter_language_instruction === undefined ? '' : filter_language_instruction.split(','),
          learning_disability: filter_learning_disability === undefined ? '' : filter_learning_disability.split(','),
          gap_year: filter_gap_year === undefined ? '' : filter_gap_year,
          business_type: filter_business_type === undefined ? '' : filter_business_type.split(','),
          location: filter_location === undefined ? '' : filter_location,
          location_type: filter_location_type === undefined ? '' : filter_location_type,
          order: filter_order === undefined ? '' : filter_order,
          processing_time: filter_processing_time === undefined ? '' : filter_processing_time.split(','),
        };

        store('vendor-filter', filter);

        this.populateFields();
      },
      getUrlParameter: function(sParam){
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;

        for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split('=');

          if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
          }
        }
      },
      populateFields: function () {
        var obj = store('vendor-filter');
        var gpa_selector = $('.filter_gpa_selector');
        var language_exams_selector = $('.filter_language_exams_selector');
        var entrance_exams_selector = $('.filter_entrance_exams_selector');

        if( typeof obj == 'object' && obj != null){
          if(obj.emoji !== ''){
            const values = obj.emoji.split(',');
            values.map(id => {
              $('.emoji-search-wrapper a[data-id="'+id+'"]').addClass('active')
            });
            $('#emoji-value').val(values.join(','));
          }

          if(obj.grade_gpa_scale1 !== ''){
            $('.gpa-slider-1').data("ionRangeSlider").update({
              from: obj.grade_gpa_scale1[0],
              to: obj.grade_gpa_scale1[1]
            });

            $('input[name=gpa_scale][value="1"]').prop('checked',true);
            gpa_selector.find('i.closed').removeClass('closed');
            gpa_selector.find('.single-filter-content').show();
          }

          if(obj.grade_gpa_scale2 !== ''){
            $('.gpa-slider-2').data('ionRangeSlider').update({
              from: obj.grade_gpa_scale2[0],
              to: obj.grade_gpa_scale2[1]
            });

            $('input[name=gpa_scale][value="2"]').prop('checked',true);
            gpa_selector.find('i.closed').removeClass('closed');
            gpa_selector.find('.single-filter-content').show();
          }

          if(obj.lang_toefl_range !== ''){
            $('.lang-toefl-slider').data('ionRangeSlider').update({
              from: obj.lang_toefl_range[0],
              to: obj.lang_toefl_range[1]
            });

            $('input[name=filter_language_exams][value="1"]').prop('checked',true);
            $('input[name=lang_scale][value="toefl"]').prop('checked',true);
            language_exams_selector.find('i.closed').removeClass('closed');
            language_exams_selector.find('.single-filter-content').show();
            language_exams_selector.find('.lang-sliders-group').show();
          }

          if(obj.lang_ielts_range !== ''){
            $('.lang-ielts-slider').data('ionRangeSlider').update({
              from: obj.lang_ielts_range[0],
              to: obj.lang_ielts_range[1]
            });

            $('input[name=filter_language_exams][value="1"]').prop('checked',true);
            $('input[name=lang_scale][value="ielts"]').prop('checked',true);
            language_exams_selector.find('i.closed').removeClass('closed');
            language_exams_selector.find('.single-filter-content').show();
            language_exams_selector.find('.lang-sliders-group').show();
          }

          if(obj.lang_itep_range !== ''){
            $('.lang-itep-slider').data('ionRangeSlider').update({
              from: obj.lang_itep_range[0],
              to: obj.lang_itep_range[1]
            });

            $('input[name=filter_language_exams][value="1"]').prop('checked',true);
            $('input[name=lang_scale][value="itep"]').prop('checked',true);
            language_exams_selector.find('i.closed').removeClass('closed');
            language_exams_selector.find('.single-filter-content').show();
            language_exams_selector.find('.lang-sliders-group').show();
          }

          if(obj.lang_duolingo_range !== ''){
            $('.lang-duolingo-slider').data('ionRangeSlider').update({
              from: obj.lang_duolingo_range[0],
              to: obj.lang_duolingo_range[1]
            });

            $('input[name=filter_language_exams][value="1"]').prop('checked',true);
            $('input[name=lang_scale][value="duolingo"]').prop('checked',true);
            language_exams_selector.find('i.closed').removeClass('closed');
            language_exams_selector.find('.single-filter-content').show();
            language_exams_selector.find('.lang-sliders-group').show();
          }

          if(obj.lang_pte_range !== ''){
            $('.lang-pte-slider').data('ionRangeSlider').update({
              from: obj.lang_pte_range[0],
              to: obj.lang_pte_range[1]
            });

            $('input[name=filter_language_exams][value="1"]').prop('checked',true);
            $('input[name=lang_scale][value="pte"]').prop('checked',true);
            language_exams_selector.find('i.closed').removeClass('closed');
            language_exams_selector.find('.single-filter-content').show();
            language_exams_selector.find('.lang-sliders-group').show();
          }

          if (obj.business_type) {
            $(".filter_business_type_selector input[name=filter_business_type]").each(function (k, el) {
              if (obj.business_type.includes($(el).val())) {
                $(el).prop("checked", true);
              }
            })
          }

          if(obj.exams_sat_range !== ''){
            $('.exams-sat-slider').data('ionRangeSlider').update({
              from: obj.exams_sat_range[0],
              to: obj.exams_sat_range[1]
            });

            $('input[name=filter_entrance_exams][value="1"]').prop('checked',true);
            $('input[name=entrance_scale][value="sat"]').prop('checked',true);
            entrance_exams_selector.find('i.closed').removeClass('closed');
            entrance_exams_selector.find('.single-filter-content').show();
            entrance_exams_selector.find('.entrance-sliders-group').show();
          }

          if(obj.exams_act_range !== ''){
            $('.exams-act-slider').data('ionRangeSlider').update({
              from: obj.exams_act_range[0],
              to: obj.exams_act_range[1]
            });

            $('input[name=filter_entrance_exams][value="1"]').prop('checked',true);
            $('input[name=entrance_scale][value="act"]').prop('checked',true);
            entrance_exams_selector.find('i.closed').removeClass('closed');
            entrance_exams_selector.find('.single-filter-content').show();
            entrance_exams_selector.find('.entrance-sliders-group').show();
          }

          if(obj.exams_igcse_range !== ''){
            $('.exams-igcse-slider').data('ionRangeSlider').update({
              from: obj.exams_igcse_range[0],
              to: obj.exams_igcse_range[1]
            });

            $('input[name=filter_entrance_exams][value="1"]').prop('checked',true);
            $('input[name=entrance_scale][value="igcse"]').prop('checked',true);
            entrance_exams_selector.find('i.closed').removeClass('closed');
            entrance_exams_selector.find('.single-filter-content').show();
            entrance_exams_selector.find('.entrance-sliders-group').show();
          }

          if(obj.exams_gmat_range !== ''){
            $('.exams-gmat-slider').data('ionRangeSlider').update({
              from: obj.exams_gmat_range[0],
              to: obj.exams_gmat_range[1]
            });

            $('input[name=filter_entrance_exams][value="1"]').prop('checked',true);
            $('input[name=entrance_scale][value="gmat"]').prop('checked',true);
            entrance_exams_selector.find('i.closed').removeClass('closed');
            entrance_exams_selector.find('.single-filter-content').show();
            entrance_exams_selector.find('.entrance-sliders-group').show();
          }

          if(obj.exams_gre_range !== ''){
            $('.exams-gre-slider').data('ionRangeSlider').update({
              from: obj.exams_gre_range[0],
              to: obj.exams_gre_range[1]
            });

            $('input[name=filter_entrance_exams][value="1"]').prop('checked',true);
            $('input[name=entrance_scale][value="gre"]').prop('checked',true);
            entrance_exams_selector.find('i.closed').removeClass('closed');
            entrance_exams_selector.find('.single-filter-content').show();
            entrance_exams_selector.find('.entrance-sliders-group').show();
          }

          if(obj.ranked !== ''){
            $('#filter_ranked').prop("checked", true);
          }

          if(obj.student_loans !== ''){
            $('#student_loans').prop("checked", true);
          }

          if(obj.gap_year !== ''){
            $('#filter_gap_year').prop("checked", true);
          }

          if(obj.show_eligible !== ''){
            $('#filter_show_eligible').val(obj.show_eligible);
          }

          if (obj.study_type !== '') {
            $('#filter_study_type').val(obj.study_type);
            this.populateProgramOptions(obj.study_type);
          }

          if (obj.program !== '') {
            $(".filter_program_selector input[name=filter_program]").each(function (k, el) {
              if (obj.program.includes($(el).val())) {
                $(el).prop('checked', true);
              }
            });
            vendorFilter.programShowSelected();
          }

          if (obj.price_range !== '') {
            var range = $(".price-range-slider").data("ionRangeSlider");
            range.update({
              from: obj.price_range[0],
              to: obj.price_range[1]
            });
          }

          if (obj.total_enrolment !== '') {
            $(".filter_total_enrolment_selector input[name=filter_total_enrolment]").each(function (k, el) {
              if (obj.total_enrolment.includes($(el).val())) {
                $(el).prop("checked", true);
              }
            })
          }

          if (obj.student_enrolment !== '') {
            $(".filter_student_enrolment_selector input[name=filter_student_enrolment]").each(function (k, el) {
              if (obj.student_enrolment.includes($(el).val())) {
                $(el).prop("checked", true);
              }
            })
          }

          if (obj.environment !== '') {
            $(".filter_environment_selector input[name=filter_environment]").each(function (k, el) {
              if (obj.environment.includes($(el).val())) {
                $(el).prop("checked", true);
              }
            })
          }

          if (obj.climate !== '') {
            $(".filter_climate_selector input[name=filter_climate]").each(function (k, el) {
              if (obj.climate.includes($(el).val())) {
                $(el).prop("checked", true);
              }
            })
          }

          if (obj.accommodation !== '') {
            $(".filter_accommodation_selector input[name=filter_accommodation]").each(function (k, el) {
              if (obj.accommodation.includes($(el).val())) {
                $(el).prop("checked", true);
              }
            })
          }

          if (obj.online_program !== '') {
            $(".filter_online_program_selector input[name=filter_online_program]").each(function (k, el) {
              if (obj.online_program.includes($(el).val())) {
                $(el).prop("checked", true);
              }
            })
          }

          if (obj.sport_teams !== '') {
            $(".filter_sport_teams_selector input[name=filter_sport_teams]").each(function (k, el) {
              if (obj.sport_teams.includes($(el).val())) {
                $(el).prop("checked", true);
              }
            })
          }

          if (obj.sport_leagues !== '') {
            $(".filter_sport_leagues_selector input[name=filter_sport_leagues]").each(function (k, el) {
              if (obj.sport_leagues.includes($(el).val())) {
                $(el).prop("checked", true);
              }
            })
          }

          if (obj.clubs !== '') {
            $(".filter_clubs_selector input[name=filter_clubs]").each(function (k, el) {
              if (obj.clubs.includes($(el).val())) {
                $(el).prop("checked", true);
              }
            })
          }

          if (obj.gender_restrictions !== '') {
            $(".filter_gender_restrictions_selector input[name=filter_gender_restrictions]").each(function (k, el) {
              if (obj.gender_restrictions.includes($(el).val())) {
                $(el).prop("checked", true);
              }
            })
          }

          if (obj.religious_affiliation !== '') {
            $(".filter_religious_affiliation_selector input[name=filter_religious_affiliation]").each(function (k, el) {
              if (obj.religious_affiliation.includes($(el).val())) {
                $(el).prop("checked", true);
              }
            })
          }

          if (obj.language_instruction !== '') {
            $(".filter_language_instruction_selector input[name=filter_language_instruction]").each(function (k, el) {
              if (obj.language_instruction.includes($(el).val())) {
                $(el).prop("checked", true);
              }
            })
          }

          if (obj.learning_disability !== '') {
            $(".filter_learning_disability_selector input[name=filter_learning_disability]").each(function (k, el) {
              if (obj.learning_disability.includes($(el).val())) {
                $(el).prop("checked", true);
              }
            })
          }

          if (obj.processing_time !== '') {
            $("input[name=filter_processing_time]").each(function (k, el) {
              if (obj.processing_time.includes($(el).val()) ) {
                $(el).prop("checked", true);
              }
            })
          }
          if (obj.location !== '') {
            locationFinder.input_data.val(obj.location);
            locationFinder.populateInput();
          }

          if (obj.location_type !== '') {
            locationFinder.input_type.val(obj.location_type);
          }

          if(obj.order){
            const ord = $('#sub-filter-sort input:radio[data-value='+obj.order+']');
            ord.prop("checked", true);
            $('.order-select').html(ord.data('title'))
          }

          vendorFilter.displayFilters(obj);
        }
      },
      loadVendors: function(mode, update_button_counter = false){
        var vf = store('vendor-filter');
        var page = $('#load-more').attr('data-page');
        if(update_button_counter) {
          page = 1;
          $('#load-more').attr('data-page',1)
        }

        if(mode === 'replace'){
          page = 1;
        }

        $.ajax({
          method: "POST",
          dataType: 'json',
          url: window.searchpage_data.ajaxurl,
          data: {
            action: 'store_search_ajax_request',
            page: page,
            vendorFilter: vf
          },
          beforeSend: function(jqXHR){
            isLoading = true;
            if (mode === 'replace') {
              loader.show()
              $('#load-more').hide();
            } else  {
              loader.show()
              $('#load-more').html('Loading');
            }
          },
          success: function(data, textStatus, jqXHR){
            isLoading = false;
            loader.hide()
            if(mode === 'replace'){
              $('#vendor_container').html(data.html);
            } else {
              $('#vendor_container').append(data.html);
              logoSlider()
            }

            if (data.ids !== ''){
              saveStats(data.ids, 2)
            }

            campusesList.init();
            eligibilityTooltip();
            applyTooltip();
            emojiTooltip();
            ranking_info_window();
            featured_info_window();

            var obj = $('#load-more');
            obj.blur();
            if (data.showNextPage) {
              var val = parseInt(obj.attr('data-page')) + 1;
              obj.attr('data-page', val).html('Load more').show();
            } else {
              obj.hide();
            }

            if (data.total !== false){
              $('.results-number').html(data.totalMessage);
            }
          },
          error: function(error){
            loader.hide()
            console.log(error);
          }
        });
      },
      populateProgramOptions: function (type_id) {
        var out = programData[type_id];
        var options = '';
        if (out) {
          var disp = 'none';

          if (out.children !== undefined) {
            out.children.forEach(function (el, index) {
            options +=
              `<label class="checkbox-container" style="display:${disp};">${el.name}
                  <input type="checkbox" name="filter_program" value="${el.term_id}">
                  <span class="checkmark"></span>
                </label>`;
            });
          }


          $('.filter_program_selector').on('change', 'input[name=filter_program]', function (e) {
            vendorFilter.programShowSelected();
            vendorFilter.submitForm();
          });

          vendorFilter.programSearchInit();

        }
        $('.filter_program_selector .options-wrapper').html(options);
      },
      programSearchInit: function (){
        var $body = $('body');
        var search_div = '<div class="hide-if-no-js">';
        search_div += '<div class="d-flex justify-content-between">';
        search_div += '<label>Search</label>';
        search_div +='<a style="padding: 0 10px; display: inline-block;" href="javascript:void(0);" class="button-link filter-program-search-clear">Clear</a>';
        search_div += '</div>';
        search_div += '<div class="filter-program-search-field-wrapper">';
        search_div += '<input type="text" name="search-field-in" class="form-control filter-program-search-field" placeholder="Search the program" style="width:100%;" />';
        search_div +='</div>';
        search_div +='</div>';

        // $(search_div).insertBefore($('.filter_program_selector .single-filter-content'));
        $('.filter_program_selector .single-filter-content').prepend(search_div);

        $.expr[':'].Contains = function(a, i, m) {
          return $(a).text().toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
        };

        $body.on('change keyup', '.filter-program-search-field', function(){
          var s = $(this).val(),
            categorydiv = $('.filter_program_selector .options-wrapper');

          if ( $.trim(s) === '' ) {
            categorydiv.first().find('.checkbox-container').show();
          } else {
            var result = categorydiv.first().find('.checkbox-container:Contains("'+s+'")');

            categorydiv.first().find('.checkbox-container').hide();
            result.each(function(){
              $(this).show();
            });

            if (result.length === 0) {
              if($('.filter_program_selector .no-result-row').length == 0){
                categorydiv.first().append('<div class="no-result-row" style="padding-left: 3px; font-size: 14px;">No results</div>');
              }
            } else {
              categorydiv.first().find('.no-result-row').remove();
            }
          }
        });

        $body.on('click', '.filter-program-search-clear', function(e){
          e.preventDefault();
          var inside =  $('.filter_program_selector .single-filter-content');

          inside.first().find('.checkbox-container').show();
          $('.filter-program-search-field').val('');
          inside.find('.no-result-row').remove();

          vendorFilter.programShowSelected();
        });
      },
      programShowSelected: function() {
        $(".filter_program_selector input[name=filter_program]").each(function (k, el) {
          if ($(el).prop('checked') === true) {
            $(el).closest('.checkbox-container').show();
          } else {
            $(el).closest('.checkbox-container').hide();
          }
        })
      },
      toggleSingleFilter: function (thisBlockClass) {
        $( thisBlockClass ).toggleClass('closed');
        $( thisBlockClass ).find('.single-filter-content').toggle();
      },
      getDefaultStudyTypeValue: function () {
        return 328;
      },
      displayFilters: function (filter) {
        /*
          325 - High School
          326 - Certificate
          327 - Associate's Degree
          328 - Bachelor's Degree
          329 - Master's Degree
        * */
        const
          gap_year = $('.filter_gap_year_selector'),
          sport_leagues = $('.filter_sport_leagues_selector'),
          clubs = $('.filter_clubs_selector'),
          learning_disability = $('.filter_learning_disability_selector'),
          language_instruction = $('.filter_language_instruction_selector'),
          exams_sat_slider = $('.wrap-exams-sat-slider'),
          exams_act_slider = $('.wrap-exams-act-slider'),
          exams_igcse_slider = $('.wrap-exams-igcse-slider'),
          exams_gmat_slider = $('.wrap-exams-gmat-slider'),
          exams_gre_slider = $('.wrap-exams-gre-slider');

        if (filter.study_type === '325'){
          gap_year.show();

          learning_disability.show();

          sport_leagues.hide();
          clubs.hide();
        } else {
          gap_year.hide();

          learning_disability.hide();
          language_instruction.addClass('no-border');

          sport_leagues.show();
          clubs.show();
        }

        if (filter.study_type === '327' || filter.study_type === '328'){
          exams_sat_slider.show();
          exams_act_slider.show();
          exams_igcse_slider.show();
        } else {
          exams_sat_slider.hide();
          exams_act_slider.hide();
          exams_igcse_slider.hide();
        }

        if (filter.study_type === '329'){
          exams_gmat_slider.show();
          exams_gre_slider.show();
        } else {
          exams_gmat_slider.hide();
          exams_gre_slider.hide();
        }
      },
      formatNumber: function (num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      },
      saveCurrentUrl: function (){
        const url = window.location.pathname + window.location.search;
        store('search-url', url);
      }
    };

    locationFinder.init();
    vendorFilter.init();
  });
}
